export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

// O loader do Google Maps falha se for chamado com opções diferentes na mesma
// página. Todos os mapas devem usar estas mesmas opções.
// Não usar preventGoogleFontsLoading: ele substitui document.head.insertBefore
// e impede o Emotion (MUI) de inserir o CSS criado depois que o Maps carrega.
export const GOOGLE_MAPS_LOADER = {
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  libraries: ['places'],
};
